import moment, { type Moment } from 'moment';
import type { NavItem } from './DrillDownTreemap/Breadcrumb';

export interface CommonTypes {
  enableSSF?: boolean;
  enableTimeSlice?: boolean;
  onSelect?: (
    payload: Array<{
      dimension?: string;
      row: { name: Array<string | undefined>; value: Array<string | undefined> };
    }>,
  ) => void;
  onResetCallback?: () => void;
  formatter?: (value: number, total?: number) => string;
}

function getMetricFilter(filter: string) {
  if (filter.includes('-')) {
    const filters = filter.split('-');
    return ['lower', 'upper'].map((v, i) => [
      {
        field: 'request_duration',
        op: v === 'lower' ? 'greater_than_or_equal_to' : 'less_than',
        value: +filters[i],
        display: +filters[i],
      },
    ]);
  }
  const lowerFilter = filter.replace(/>=?/g, '');
  return [
    [
      {
        field: 'request_duration',
        op: 'greater_than_or_equal_to',
        value: +lowerFilter,
        display: +lowerFilter,
      },
    ],
  ];
}

export function getFilters(navs: NavItem[]) {
  const tempFilters = navs.filter((i) => i.filter) as Required<NavItem>[];
  const filters: any[] = [];
  const metricFilters: any[] = [];
  tempFilters.forEach(({ filter }) => {
    if (filter.type === 'filter') {
      filters.push([
        {
          _order: 0,
          display: filter.value,
          field: filter.key,
          key: null,
          op: 'eq',
          originalField: filter.key,
          value: filter.value,
          defaultFilter: true,
        },
      ]);
    } else {
      metricFilters.push(...getMetricFilter(filter.value));
    }
  });
  return {
    filters,
    metricFilters,
  };
}

export const MAX_INTERVAL = 24 * 60 * 60; // 24 hours in seconds
export function validateInterval({ from, to }: { from: Moment; to: Moment }) {
  const diff = moment(to).diff(from, 'seconds');
  return diff <= MAX_INTERVAL;
}
